module.exports = __webpack_public_path__ + "img/signal_cellular_2_bar-yellow.6a7a0f42.svg";